import Workday from './Workday.vue'

export default Workday
